import { yup } from '@guiker/yup-util'

const payInMethodMigrationQueryParamsSchema = yup.object({
  page: yup.number().integer().min(0),
})

export { payInMethodMigrationQueryParamsSchema }
